import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { ClientSideStorageService } from 'src/app/services/client-side-storage.service';
import { DashboardService } from 'src/app/services/dashboard.service';
import { environment } from 'src/environments/environment';
import { ChartConfiguration, ChartType } from 'chart.js';

export interface AgeRange {
  label: string;
  minAge: number;
  maxAge: number;
  code: number;
}

@Component({
  selector: 'app-deal-events',
  templateUrl: './deal-events.component.html',
  styleUrl: './deal-events.component.scss'
})
export class DealEventsComponent implements OnInit {

  eventCountLabels: string[] = [];
  eventCountData: any;
  genderLabels: string[] = [];
  genderData: any;
  locationLabels: string[] = [];
  locationData: any;

  placeholders = environment.placeholders as { [key: string]: string };
  @ViewChild('subsectionContent') subsectionContent!: ElementRef;
  deal_id: any
  deal: any;
  dealimage: any;
  userData: any
  isEventCountVisible = true;
  isGenderVisible = false;
  isLocationVisible = false;
  isAgeRangeVisible = false;
  selectedSection: string = 'all';
  reportTotalDeals: any
  reportTotalBudget: any
  reportTotalSpent: any
  reportSpendCharged: any
  reportPlaceHolders: any

  ageRanges: AgeRange[] = [
    // { label: 'All', minAge: 1, maxAge: 100, code: 0 },
    // { label: '18-25', minAge: 18, maxAge: 25, code: 1 },
    // { label: '26-40', minAge: 26, maxAge: 40, code: 2 },
    // { label: '41-60', minAge: 41, maxAge: 60, code: 3 },
    // { label: '61-Above', minAge: 61, maxAge: 100, code: 4 },

    { label: '0-13', minAge: 0, maxAge: 13, code: 0 },
    { label: '13-17', minAge: 0, maxAge: 13, code: 1 },
    { label: '18-25', minAge: 18, maxAge: 25, code: 2 },
    { label: '26-40', minAge: 26, maxAge: 40, code: 3 },
    { label: '41-60', minAge: 41, maxAge: 60, code: 4 },
    { label: '61-100', minAge: 41, maxAge: 60, code: 5 },
    { label: '100-Above', minAge: 61, maxAge: 100, code: 6 },
  ];

  eventSummary = {
    eventCountReports: [
      { eventType: 'DEAL_FAVOURITE_EVENT', eventCount: 2, totalCostByEventType: 0.06 },
      { eventType: 'DEAL_CLICK_EVENT', eventCount: 2, totalCostByEventType: 0.2 },
      { eventType: 'DEAL_IMPRESSIONS_EVENT', eventCount: 329, totalCostByEventType: 0.0 },
      { eventType: 'REPEATED_DEAL_CLICK', eventCount: 1, totalCostByEventType: 0.0 }
    ],
    userCountByGenderReports: [
      {
        gender: 'Unknown',
        details: [{ eventType: 'DEAL_IMPRESSIONS_EVENT', eventCount: 58, totalCost: 0.0 }]
      },
      {
        gender: 'Female',
        details: [
          { eventType: 'DEAL_IMPRESSIONS_EVENT', eventCount: 223, totalCost: 0.0 },
          { eventType: 'DEAL_CLICK_EVENT', eventCount: 1, totalCost: 0.1 },
          { eventType: 'DEAL_FAVOURITE_EVENT', eventCount: 1, totalCost: 0.03 }
        ]
      },
      {
        gender: 'Male',
        details: [
          { eventType: 'DEAL_IMPRESSIONS_EVENT', eventCount: 48, totalCost: 0.0 },
          { eventType: 'REPEATED_DEAL_CLICK', eventCount: 1, totalCost: 0.0 },
          { eventType: 'DEAL_FAVOURITE_EVENT', eventCount: 1, totalCost: 0.03 },
          { eventType: 'DEAL_CLICK_EVENT', eventCount: 1, totalCost: 0.1 }
        ]
      }
    ],
    eventCountByLocationReports: [
      {
        country: 'Botswana',
        state: 'Gaborone',
        city: 'Gaborone',
        details: [
          { eventType: 'DEAL_IMPRESSIONS_EVENT', eventCount: 317, totalCost: 0.0 },
          { eventType: 'DEAL_CLICK_EVENT', eventCount: 1, totalCost: 0.1 },
          { eventType: 'DEAL_FAVOURITE_EVENT', eventCount: 1, totalCost: 0.03 }
        ]
      },
      {
        country: 'Botswana',
        state: 'Gaborone',
        city: '',
        details: [
          { eventType: 'DEAL_FAVOURITE_EVENT', eventCount: 1, totalCost: 0.03 },
          { eventType: 'DEAL_IMPRESSIONS_EVENT', eventCount: 4, totalCost: 0.0 }
        ]
      },
      {
        country: 'Botswana',
        state: 'Central District',
        city: 'Dukwi',
        details: [
          { eventType: 'DEAL_CLICK_EVENT', eventCount: 1, totalCost: 0.1 },
          { eventType: 'REPEATED_DEAL_CLICK', eventCount: 1, totalCost: 0.0 },
          { eventType: 'DEAL_IMPRESSIONS_EVENT', eventCount: 8, totalCost: 0.0 }
        ]
      }
    ],
    eventCountByAgeRangeReports: [
      {
        ageRange: 0,
        details: [{ eventType: 'DEAL_IMPRESSIONS_EVENT', eventCount: 58, totalCost: 0.0 }]
      },
      {
        ageRange: 2,
        details: [
          { eventType: 'REPEATED_DEAL_CLICK', eventCount: 1, totalCost: 0.0 },
          { eventType: 'DEAL_CLICK_EVENT', eventCount: 1, totalCost: 0.1 },
          { eventType: 'DEAL_IMPRESSIONS_EVENT', eventCount: 8, totalCost: 0.0 }
        ]
      },
      {
        ageRange: 3,
        details: [
          { eventType: 'DEAL_FAVOURITE_EVENT', eventCount: 2, totalCost: 0.06 },
          { eventType: 'DEAL_IMPRESSIONS_EVENT', eventCount: 263, totalCost: 0.0 },
          { eventType: 'DEAL_CLICK_EVENT', eventCount: 1, totalCost: 0.1 }
        ]
      }
    ]
  };

  constructor(private dashboardService: DashboardService, private router: Router, private _activateRoute: ActivatedRoute, private clientStorage: ClientSideStorageService) {
    this.userData = JSON.parse(this.clientStorage.get("marketplaceData"));
    // this.deal_id = this._activateRoute.snapshot.paramMap.get('id');
    this.reportPlaceHolders = this.placeholders['Reports_page']
    const navigation = this.router.getCurrentNavigation();
    this.deal = navigation?.extras?.state?.['deal'];
    if (!this.deal) {
      this.router.navigate(['/eventreport'])
    }
    // this.reportTotalDeals = res?.body?.data?.TOTAL_DEALS;
    this.reportTotalSpent = this.deal.total_spent;
    this.reportTotalBudget = this.deal.budget;
    this.reportSpendCharged = this.deal.spentAlreadyCharged;
    this.deal_id = this.deal.product_id
    this.dealimage = environment.assetsUrl + '/assets/' + this.deal?.product_image

  }

  ngOnInit() {

    this.getAllDealEvents()

  }

  prepareCharts() {
    debugger
    // --- Event Count Summary ---
    const events = this.eventSummary.eventCountReports || [];
    this.eventCountLabels = events.map(e => e.eventType);
    this.eventCountData = {
      labels: this.eventCountLabels,
      datasets: [{
        label: 'Event Count',
        data: events.map(e => e.eventCount),
        backgroundColor: '#42A5F5'
      }]
    };

    // --- Gender Chart ---
    const genders = this.eventSummary.userCountByGenderReports || [];
    this.genderLabels = genders.map(g => g.gender);
    const totalCounts = genders.map(g =>
      g.details.reduce((sum: number, d: any) => sum + d.eventCount, 0)
    );
    this.genderData = {
      labels: this.genderLabels,
      datasets: [{
        data: totalCounts,
        backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56']
      }]
    };

    // --- Location Chart ---
    const locations = this.eventSummary.eventCountByLocationReports || [];
    this.locationLabels = locations.map(l => `${l.city} (${l.state})`);
    const totalPerLocation = locations.map(l =>
      l.details.reduce((sum: number, d: any) => sum + d.eventCount, 0)
    );
    this.locationData = {
      labels: this.locationLabels,
      datasets: [{
        data: totalPerLocation,
        backgroundColor: ['#4BC0C0', '#FF9F40', '#9966FF', '#FF6384']
      }]
    };
  }


  getAllDealEvents() {
    const payload = {
      dealId: this.deal_id,
      brandId: this.userData.marketplace_id
    };

    this.dashboardService.getAllDealEvents(payload).subscribe({
      next: (res: any) => {
        if (res && res?.body?.data) {
          this.eventSummary = res.body.data;
          // ✅ Call prepareCharts only after data is loaded
          this.prepareCharts();
        }
      },
      error: (err: any) => {
        console.error('Error fetching deal events:', err);
      }
    });
  }


  // getAllDealEvents() {

  //   let payload = {
  //     dealId: this.deal_id,
  //     brandId: this.userData.marketplace_id
  //   }

  //   this.dashboardService.getAllDealEvents(payload).subscribe((res: any) => {

  //     debugger
  //     if (res && res?.body.data) {
  //       this.eventSummary = res?.body.data
  //     }
  //   });

  //       this.prepareCharts();
  // }

  toggleSubsection(section: string): void {
    switch (section) {
      case 'eventCount':
        this.isEventCountVisible = !this.isEventCountVisible;
        break;
      case 'gender':
        this.isGenderVisible = !this.isGenderVisible;
        break;
      case 'location':
        this.isLocationVisible = !this.isLocationVisible;
        break;
      case 'ageRange':
        this.isAgeRangeVisible = !this.isAgeRangeVisible;
        break;
    }
  }

  getAgeRangeLabel(code: number): string {
    const match = this.ageRanges.find(range => range.code === code);
    return match ? match.label : 'Unknown';
  }



  exportToPDF1(dealUUID: string) {
    debugger
    const deal = this.deal
    if (!deal) return;

    const pdf = new jsPDF();
    const title = `Deal Events Report - ${deal.product_name}`;
    pdf.setFontSize(16);
    pdf.setTextColor(40);
    pdf.text(title, 14, 20);
    let currentY = 30;

    // Add Deal Header Info
    pdf.setFontSize(12);
    if (deal.dealType === 'promotions') {
      pdf.text(`Discounted Price: ${deal.coupon_code}`, 14, currentY);
    } else {
      pdf.text(`Coupon Code: ${deal.coupon_code}`, 14, currentY);
    }

    currentY += 6;


    const descriptionText = `Description: ${this.deal.product_description}`;
    const wrappedDescription = pdf.splitTextToSize(descriptionText, 150); // max width for wrapping

    pdf.text(wrappedDescription, 14, currentY); // render wrapped lines
    currentY = 39 + (wrappedDescription.length * 5);
    currentY += 10;
    // Draw horizontal line
    pdf.setDrawColor(0);
    pdf.setLineWidth(0.5);
    pdf.line(14, currentY, 200, currentY);




    currentY += 5; // Position below line
    pdf.setFontSize(11);
    pdf.setFont('helvetica', 'bold');

    // pdf.text( `Total Deals:`,20, currentY);
    // pdf.text( `${this.reportTotalDeals}`,45, currentY);

    pdf.text(`Budget:`, 20, currentY);
    pdf.text(`$${this.reportTotalBudget}`, 45, currentY);

    pdf.text(`Total Spent:`, 65, currentY);
    pdf.text(`$${this.reportTotalSpent}`, 90, currentY);

    pdf.text(`Charged Till Now:`, 120, currentY);
    pdf.text(`$${this.reportSpendCharged}`, 155, currentY);

    currentY += 2;
    pdf.setLineWidth(0.5); // Set line thickness
    pdf.line(14, currentY, 200, currentY);

    currentY += 6;
    const addSection = (sectionTitle: string, headers: string[], data: any[][]) => {
      pdf.setFontSize(12);
      pdf.text(sectionTitle, 14, currentY);
      currentY += 5;
      autoTable(pdf, {
        startY: currentY,
        head: [headers],
        body: data.length > 0 ? data : [['No records', '', '']],
        theme: 'grid',
        styles: {
          cellPadding: 3,
          fontSize: 10,
          overflow: 'linebreak',
        },
        headStyles: { fillColor: [41, 128, 185] },
        didDrawPage: (data) => {
          if (data.cursor?.y != null) {
            currentY = data.cursor.y + 10;
          }
        }
      });
    };

    if (this.selectedSection === 'all' || this.selectedSection === 'eventCount') {
      const data = this.eventSummary?.eventCountReports?.map((e: any) => [
        e.eventType, e.eventCount, e.totalCostByEventType
      ]) || [];
      addSection('Event Count Summary', ['Event Type', 'Count', 'Total Cost'], data);
    }

    if (this.selectedSection === 'all' || this.selectedSection === 'gender') {
      const genderReports = this.eventSummary?.userCountByGenderReports || [];
      genderReports.forEach((genderReport: any) => {
        pdf.setFontSize(12);
        pdf.text(`Gender: ${genderReport.gender}`, 14, currentY);
        currentY += 4;
        const details = genderReport.details?.map((d: any) => [
          d.eventType, d.eventCount, d.totalCost
        ]) || [];
        autoTable(pdf, {
          startY: currentY,
          head: [['Event Type', 'Count', 'Total Cost']],
          body: details.length > 0 ? details : [['No records', '', '']],
          theme: 'grid',
          styles: {
            cellPadding: 3,
            fontSize: 10,
            overflow: 'linebreak',
          },
          headStyles: { fillColor: [41, 128, 185] },
          didDrawPage: (data) => {
            if (data.cursor?.y != null) {
              currentY = data.cursor.y + 10;
            }
          }
        });
      });
    }

    if (this.selectedSection === 'all' || this.selectedSection === 'location') {
      const locationReports = this.eventSummary?.eventCountByLocationReports || [];
      locationReports.forEach((locReport: any) => {
        pdf.setFontSize(12);
        pdf.text(`Location: ${locReport.city} ${locReport.state} ${locReport.country}`, 14, currentY);
        currentY += 4;
        const details = locReport.details?.map((d: any) => [
          d.eventType, d.eventCount, d.totalCost
        ]) || [];
        autoTable(pdf, {
          startY: currentY,
          head: [['Event Type', 'Count', 'Total Cost']],
          body: details.length > 0 ? details : [['No records', '', '']],
          theme: 'grid',
          styles: {
            cellPadding: 3,
            fontSize: 10,
            overflow: 'linebreak',
          },
          headStyles: { fillColor: [41, 128, 185] },
          didDrawPage: (data) => {
            if (data.cursor?.y != null) {
              currentY = data.cursor.y + 10;
            }
          }
        });
      });
    }

    if (this.selectedSection === 'all' || this.selectedSection === 'ageRange') {
      const ageReports = this.eventSummary?.eventCountByAgeRangeReports || [];
      ageReports.forEach((ageReport: any) => {
        pdf.setFontSize(12);
        pdf.text(`Age Range: ${this.getAgeRangeLabel(ageReport.ageRange)}`, 14, currentY);
        currentY += 4;
        const details = ageReport.details?.map((d: any) => [
          d.eventType, d.eventCount, d.totalCost
        ]) || [];
        autoTable(pdf, {
          startY: currentY,
          head: [['Event Type', 'Count', 'Total Cost']],
          body: details.length > 0 ? details : [['No records', '', '']],
          theme: 'grid',
          styles: {
            cellPadding: 3,
            fontSize: 10,
            overflow: 'linebreak',
          },
          headStyles: { fillColor: [41, 128, 185] },
          didDrawPage: (data) => {
            if (data.cursor?.y != null) {
              currentY = data.cursor.y + 10;
            }
          }
        });
      });
    }

    pdf.save(`Deal_${deal.uuid}_${this.selectedSection}.pdf`);
  }


  exportToPDF2(dealUUID: string) {
    const deal = this.deal;
    if (!deal) return;

    const pdf = new jsPDF();
    let currentY = 20;

    // --- Deal Image on the left ---
    const productImg = environment.assetsUrl + `/assets/${deal.product_image}`;
    const img = new Image();
    img.crossOrigin = 'Anonymous';
    img.src = productImg;

    img.onload = () => {
      const imgWidth = 40; // Adjust as needed
      const imgHeight = (img.height / img.width) * imgWidth;
      pdf.addImage(img, 'PNG', 14, currentY, imgWidth, imgHeight);

      // --- Deal Title + Status ---
      let textX = 14 + imgWidth + 10; // some space after image
      pdf.setFontSize(14);
      pdf.setFont('helvetica', 'bold');
      pdf.text(`${deal.product_name}`, textX, currentY + 8);

      // // Status pill
      // pdf.setFillColor(76, 175, 80); // green
      // pdf.roundedRect(textX + 60, currentY - 2, 25, 8, 2, 2, 'F'); // x, y, w, h, rx, ry
      // pdf.setFontSize(10);
      // pdf.setTextColor(255);
      // pdf.text('Active', textX + 63, currentY + 4);

      // pdf.setTextColor(0);

      // Subtitle
      pdf.setFontSize(11);
      pdf.setFont('helvetica', 'normal');
      pdf.text(
        `${deal.product_name} - created_by_entity`,
        textX,
        currentY + 15
      );
      if (deal.dealType === 'promotions') {
        pdf.text(`Discounted Price:`, textX, currentY + 25);
        pdf.setFont('helvetica', 'normal');
        pdf.text(`${deal.discountedPrice}`, textX + 30, currentY + 25);
      } else {
        pdf.text(`Coupon Code:`, textX, currentY + 25);
        pdf.setFont('helvetica', 'normal');
        pdf.text(`${deal.coupon_code}`, textX + 30, currentY + 25);
      }

      const descriptionText = `Description: ${this.deal.product_description}`;
      const wrappedDescription = pdf.splitTextToSize(descriptionText, 100); // max width for wrapping

      pdf.text(wrappedDescription, textX, currentY + 35); // render wrapped lines
      currentY = 10 + (wrappedDescription.length * 5);

      // --- Dates + Coupon/Discount info below ---
      let infoY = currentY + imgHeight + 10;
      // pdf.setFontSize(11);
      // pdf.setFont('helvetica', 'bold');

      // pdf.text(`Created On:`, 14, infoY);
      // pdf.setFont('helvetica', 'normal');
      // pdf.text(`${deal.createdOn}`, 45, infoY);

      // pdf.setFont('helvetica', 'bold');
      // pdf.text(`Date From:`, 85, infoY);
      // pdf.setFont('helvetica', 'normal');
      // pdf.text(`${deal.dateFrom}`, 115, infoY);

      // pdf.setFont('helvetica', 'bold');
      // pdf.text(`Date To:`, 145, infoY);
      // pdf.setFont('helvetica', 'normal');
      // pdf.text(`${deal.dateTo}`, 170, infoY);

      // infoY += 8;
      // pdf.setFont('helvetica', 'bold');
      // if (deal.dealType === 'promotions') {
      //   pdf.text(`Discounted Price:`, 14, infoY);
      //   pdf.setFont('helvetica', 'normal');
      //   pdf.text(`${deal.discountedPrice}`, 55, infoY);
      // } else {
      //   pdf.text(`Coupon Code:`, 14, infoY);
      //   pdf.setFont('helvetica', 'normal');
      //   pdf.text(`${deal.coupon_code}`, 55, infoY);
      // }

      // move currentY for your existing report sections
      currentY = infoY + 10;



      currentY += 5;
      // Draw horizontal line
      pdf.setDrawColor(0);
      pdf.setLineWidth(0.5);
      pdf.line(14, currentY, 200, currentY);




      currentY += 5; // Position below line
      pdf.setFontSize(11);
      pdf.setFont('helvetica', 'bold');

      // pdf.text( `Total Deals:`,20, currentY);
      // pdf.text( `${this.reportTotalDeals}`,45, currentY);

      pdf.text(`Budget:`, 20, currentY);
      pdf.text(`$${this.reportTotalBudget}`, 45, currentY);

      pdf.text(`Total Spent:`, 65, currentY);
      pdf.text(`$${this.reportTotalSpent}`, 90, currentY);

      pdf.text(`Charged Till Now:`, 120, currentY);
      pdf.text(`$${this.reportSpendCharged}`, 155, currentY);

      currentY += 2;
      pdf.setLineWidth(0.5); // Set line thickness
      pdf.line(14, currentY, 200, currentY);

      currentY += 6;
      const addSection = (sectionTitle: string, headers: string[], data: any[][]) => {
        pdf.setFontSize(12);
        pdf.text(sectionTitle, 14, currentY);
        currentY += 5;
        autoTable(pdf, {
          startY: currentY,
          head: [headers],
          body: data.length > 0 ? data : [['No records', '', '']],
          theme: 'grid',
          styles: {
            cellPadding: 3,
            fontSize: 10,
            overflow: 'linebreak',
          },
          headStyles: { fillColor: [41, 128, 185] },
          didDrawPage: (data) => {
            if (data.cursor?.y != null) {
              currentY = data.cursor.y + 10;
            }
          }
        });
      };

      if (this.selectedSection === 'all' || this.selectedSection === 'eventCount') {
        const data = this.eventSummary?.eventCountReports?.map((e: any) => [
          e.eventType, e.eventCount, e.totalCostByEventType
        ]) || [];
        addSection('Event Count Summary', ['Event Type', 'Count', 'Total Cost'], data);
      }

      if (this.selectedSection === 'all' || this.selectedSection === 'gender') {
        const genderReports = this.eventSummary?.userCountByGenderReports || [];
        genderReports.forEach((genderReport: any) => {
          pdf.setFontSize(12);
          pdf.text(`Gender: ${genderReport.gender}`, 14, currentY);
          currentY += 4;
          const details = genderReport.details?.map((d: any) => [
            d.eventType, d.eventCount, d.totalCost
          ]) || [];
          autoTable(pdf, {
            startY: currentY,
            head: [['Event Type', 'Count', 'Total Cost']],
            body: details.length > 0 ? details : [['No records', '', '']],
            theme: 'grid',
            styles: {
              cellPadding: 3,
              fontSize: 10,
              overflow: 'linebreak',
            },
            headStyles: { fillColor: [41, 128, 185] },
            didDrawPage: (data) => {
              if (data.cursor?.y != null) {
                currentY = data.cursor.y + 10;
              }
            }
          });
        });
      }

      if (this.selectedSection === 'all' || this.selectedSection === 'location') {
        const locationReports = this.eventSummary?.eventCountByLocationReports || [];
        locationReports.forEach((locReport: any) => {
          pdf.setFontSize(12);
          pdf.text(`Location: ${locReport.city} ${locReport.state} ${locReport.country}`, 14, currentY);
          currentY += 4;
          const details = locReport.details?.map((d: any) => [
            d.eventType, d.eventCount, d.totalCost
          ]) || [];
          autoTable(pdf, {
            startY: currentY,
            head: [['Event Type', 'Count', 'Total Cost']],
            body: details.length > 0 ? details : [['No records', '', '']],
            theme: 'grid',
            styles: {
              cellPadding: 3,
              fontSize: 10,
              overflow: 'linebreak',
            },
            headStyles: { fillColor: [41, 128, 185] },
            didDrawPage: (data) => {
              if (data.cursor?.y != null) {
                currentY = data.cursor.y + 10;
              }
            }
          });
        });
      }

      if (this.selectedSection === 'all' || this.selectedSection === 'ageRange') {
        const ageReports = this.eventSummary?.eventCountByAgeRangeReports || [];
        ageReports.forEach((ageReport: any) => {
          pdf.setFontSize(12);
          pdf.text(`Age Range: ${this.getAgeRangeLabel(ageReport.ageRange)}`, 14, currentY);
          currentY += 4;
          const details = ageReport.details?.map((d: any) => [
            d.eventType, d.eventCount, d.totalCost
          ]) || [];
          autoTable(pdf, {
            startY: currentY,
            head: [['Event Type', 'Count', 'Total Cost']],
            body: details.length > 0 ? details : [['No records', '', '']],
            theme: 'grid',
            styles: {
              cellPadding: 3,
              fontSize: 10,
              overflow: 'linebreak',
            },
            headStyles: { fillColor: [41, 128, 185] },
            didDrawPage: (data) => {
              if (data.cursor?.y != null) {
                currentY = data.cursor.y + 10;
              }
            }
          });
        });
      }

      pdf.save(`Deal_${deal.uuid}_${this.selectedSection}.pdf`);
      // ----------------------------
      // Your existing PDF report code here
      // ----------------------------
    };
  }


  exportToPDF3(dealUUID: string) {
    const deal = this.deal;
    if (!deal) return;

    const pdf = new jsPDF();
    let currentY = 20;

    const productImg = environment.assetsUrl + `/assets/${deal.product_image}`;
    const img = new Image();
    img.crossOrigin = 'Anonymous';
    img.src = productImg;

    // Helper function to render the rest of PDF (without depending on image)
    const renderPDF = (imgLoaded: boolean, imgRef?: HTMLImageElement) => {
      try {
        // --- Deal Image ---
        let imgWidth = 40;
        let imgHeight = 0;
        if (imgLoaded && imgRef) {
          imgHeight = (imgRef.height / imgRef.width) * imgWidth;
          pdf.addImage(imgRef, 'PNG', 14, currentY, imgWidth, imgHeight);
        }

        // --- Deal Title + Status ---
        let textX = imgLoaded ? 14 + imgWidth + 10 : 14; // shift right only if image exists
        pdf.setFontSize(14);
        pdf.setFont('helvetica', 'bold');
        pdf.text(`${deal.product_name}`, textX, currentY + 8);

        // Subtitle
        pdf.setFontSize(11);
        pdf.setFont('helvetica', 'normal');
        pdf.text(`${deal.product_name} - created_by_entity`, textX, currentY + 15);

        // Discount or Coupon
        if (deal.dealType === 'promotions') {
          pdf.text(`Discounted Price:`, textX, currentY + 25);
          pdf.setFont('helvetica', 'normal');
          pdf.text(`${deal.discountedPrice}`, textX + 40, currentY + 25);
        } else {
          pdf.text(`Coupon Code:`, textX, currentY + 25);
          pdf.setFont('helvetica', 'normal');
          pdf.text(`${deal.coupon_code}`, textX + 40, currentY + 25);
        }

        // Description
        const descriptionText = `Description: ${this.deal.product_description}`;
        const wrappedDescription = pdf.splitTextToSize(descriptionText, 100);
        pdf.text(wrappedDescription, textX, currentY + 35);
        currentY = currentY + 35 + (wrappedDescription.length * 5);

        // --- Horizontal Line ---
        currentY += 5;
        pdf.setDrawColor(0);
        pdf.setLineWidth(0.5);
        pdf.line(14, currentY, 200, currentY);

        currentY += 5;
        pdf.setFontSize(11);
        pdf.setFont('helvetica', 'bold');

        // Budget/Spend info
        pdf.text(`Budget:`, 20, currentY);
        pdf.text(`$${this.reportTotalBudget}`, 45, currentY);

        pdf.text(`Total Spent:`, 65, currentY);
        pdf.text(`$${this.reportTotalSpent}`, 100, currentY);

        pdf.text(`Charged Till Now:`, 130, currentY);
        pdf.text(`$${this.reportSpendCharged}`, 170, currentY);

        currentY += 6;
        pdf.setLineWidth(0.5);
        pdf.line(14, currentY, 200, currentY);

        currentY += 10;

        // Helper for reusable section
        const addSection = (sectionTitle: string, headers: string[], data: any[][]) => {
          pdf.setFontSize(12);
          pdf.text(sectionTitle, 14, currentY);
          currentY += 5;
          autoTable(pdf, {
            startY: currentY,
            head: [headers],
            body: data.length > 0 ? data : [['No records', '', '']],
            theme: 'grid',
            styles: {
              cellPadding: 3,
              fontSize: 10,
              overflow: 'linebreak',
            },
            headStyles: { fillColor: [41, 128, 185] },
            didDrawPage: (data) => {
              if (data.cursor?.y != null) {
                currentY = data.cursor.y + 10;
              }
            }
          });
        };

        // Sections
        if (this.selectedSection === 'all' || this.selectedSection === 'eventCount') {
          const data = this.eventSummary?.eventCountReports?.map((e: any) => [
            e.eventType, e.eventCount, e.totalCostByEventType
          ]) || [];
          addSection('Event Count Summary', ['Event Type', 'Count', 'Total Cost'], data);
        }

        if (this.selectedSection === 'all' || this.selectedSection === 'gender') {
          const genderReports = this.eventSummary?.userCountByGenderReports || [];
          genderReports.forEach((genderReport: any) => {
            pdf.setFontSize(12);
            pdf.text(`Gender: ${genderReport.gender}`, 14, currentY);
            currentY += 4;
            const details = genderReport.details?.map((d: any) => [
              d.eventType, d.eventCount, d.totalCost
            ]) || [];
            autoTable(pdf, {
              startY: currentY,
              head: [['Event Type', 'Count', 'Total Cost']],
              body: details.length > 0 ? details : [['No records', '', '']],
              theme: 'grid',
              styles: { cellPadding: 3, fontSize: 10, overflow: 'linebreak' },
              headStyles: { fillColor: [41, 128, 185] },
              didDrawPage: (data) => { if (data.cursor?.y != null) currentY = data.cursor.y + 10; }
            });
          });
        }

        if (this.selectedSection === 'all' || this.selectedSection === 'location') {
          const locationReports = this.eventSummary?.eventCountByLocationReports || [];
          locationReports.forEach((locReport: any) => {
            pdf.setFontSize(12);
            pdf.text(`Location: ${locReport.city} ${locReport.state} ${locReport.country}`, 14, currentY);
            currentY += 4;
            const details = locReport.details?.map((d: any) => [
              d.eventType, d.eventCount, d.totalCost
            ]) || [];
            autoTable(pdf, {
              startY: currentY,
              head: [['Event Type', 'Count', 'Total Cost']],
              body: details.length > 0 ? details : [['No records', '', '']],
              theme: 'grid',
              styles: { cellPadding: 3, fontSize: 10, overflow: 'linebreak' },
              headStyles: { fillColor: [41, 128, 185] },
              didDrawPage: (data) => { if (data.cursor?.y != null) currentY = data.cursor.y + 10; }
            });
          });
        }

        if (this.selectedSection === 'all' || this.selectedSection === 'ageRange') {
          const ageReports = this.eventSummary?.eventCountByAgeRangeReports || [];
          ageReports.forEach((ageReport: any) => {
            pdf.setFontSize(12);
            pdf.text(`Age Range: ${this.getAgeRangeLabel(ageReport.ageRange)}`, 14, currentY);
            currentY += 4;
            const details = ageReport.details?.map((d: any) => [
              d.eventType, d.eventCount, d.totalCost
            ]) || [];
            autoTable(pdf, {
              startY: currentY,
              head: [['Event Type', 'Count', 'Total Cost']],
              body: details.length > 0 ? details : [['No records', '', '']],
              theme: 'grid',
              styles: { cellPadding: 3, fontSize: 10, overflow: 'linebreak' },
              headStyles: { fillColor: [41, 128, 185] },
              didDrawPage: (data) => { if (data.cursor?.y != null) currentY = data.cursor.y + 10; }
            });
          });
        }

        pdf.save(`Deal_${deal.uuid}_${this.selectedSection}.pdf`);
      } catch (err) {
        console.error('PDF render error:', err);
        pdf.save(`Deal_${deal.uuid}_${this.selectedSection}_partial.pdf`);
      }
    };

    // Try to load image
    img.onload = () => renderPDF(true, img);
    img.onerror = () => {
      console.warn('Image load failed, skipping image...');
      renderPDF(false);
    };
  }

  exportToPDF4(dealUUID: string) {
    const deal = this.deal;
    if (!deal) return;

    const pdf = new jsPDF();
    let currentY = 20;

    const productImg = environment.assetsUrl + `/assets/${deal.product_image}`;
    const img = new Image();
    img.crossOrigin = 'Anonymous';
    img.src = productImg;

    // --- Common PDF body logic ---
    const renderPDF = (imgRef?: HTMLImageElement) => {
      try {
        // --- Deal Image (optional) ---
        let imgWidth = 40;
        let imgHeight = 0;
        if (imgRef) {
          try {
            imgHeight = (imgRef.height / imgRef.width) * imgWidth;
            pdf.addImage(imgRef, 'PNG', 14, currentY, imgWidth, imgHeight);
          } catch (e) {
            console.warn('Image could not be added:', e);
          }
        }

        // --- Deal Title + Status ---
        let textX = imgRef ? 14 + imgWidth + 10 : 14;
        pdf.setFontSize(14);
        pdf.setFont('helvetica', 'bold');
        pdf.text(`${deal.product_name}`, textX, currentY + 8);

        // Subtitle
        pdf.setFontSize(11);
        pdf.setFont('helvetica', 'normal');
        pdf.text(`${deal.product_name} - created_by_entity`, textX, currentY + 15);

        // Discount or Coupon
        if (deal.dealType === 'promotions') {
          pdf.text(`Discounted Price:`, textX, currentY + 25);
          pdf.text(`${deal.discountedPrice}`, textX + 40, currentY + 25);
        } else {
          pdf.text(`Coupon Code:`, textX, currentY + 25);
          pdf.text(`${deal.coupon_code}`, textX + 40, currentY + 25);
        }

        // Description
        const descriptionText = `Description: ${this.deal.product_description}`;
        const wrappedDescription = pdf.splitTextToSize(descriptionText, 100);
        pdf.text(wrappedDescription, textX, currentY + 35);
        currentY = currentY + 35 + (wrappedDescription.length * 5);

        // --- Horizontal Line ---
        currentY += 5;
        pdf.setDrawColor(0);
        pdf.setLineWidth(0.5);
        pdf.line(14, currentY, 200, currentY);

        currentY += 5;
        pdf.setFontSize(11);
        pdf.setFont('helvetica', 'bold');

        // Budget/Spend info
        pdf.text(`Budget:`, 20, currentY);
        pdf.text(`$${this.reportTotalBudget}`, 45, currentY);

        pdf.text(`Total Spent:`, 65, currentY);
        pdf.text(`$${this.reportTotalSpent}`, 100, currentY);

        pdf.text(`Charged Till Now:`, 130, currentY);
        pdf.text(`$${this.reportSpendCharged}`, 170, currentY);

        currentY += 6;
        pdf.setLineWidth(0.5);
        pdf.line(14, currentY, 200, currentY);

        currentY += 10;

        // Helper for reusable section
        const addSection = (sectionTitle: string, headers: string[], data: any[][]) => {
          pdf.setFontSize(12);
          pdf.text(sectionTitle, 14, currentY);
          currentY += 5;
          autoTable(pdf, {
            startY: currentY,
            head: [headers],
            body: data.length > 0 ? data : [['No records', '', '']],
            theme: 'grid',
            styles: { cellPadding: 3, fontSize: 10, overflow: 'linebreak' },
            headStyles: { fillColor: [41, 128, 185] },
            didDrawPage: (data) => {
              if (data.cursor?.y != null) {
                currentY = data.cursor.y + 10;
              }
            }
          });
        };

        // ✅ Helper: render chart below the table (not full page)
        const addChartInline = (chartId: string, title: string) => {
          const canvas = document.getElementById(chartId) as HTMLCanvasElement;
          if (!canvas) return;

          const chartImg = canvas.toDataURL('image/png', 1.0);
          const chartWidth = 90; // half page width
          const chartHeight = 60; // smaller height

          // Check for page overflow
          if (currentY + chartHeight + 10 > 280) {
            pdf.addPage();
            currentY = 20;
          }

          pdf.setFontSize(11);
          pdf.text(title, 14, currentY);
          currentY += 5;

          pdf.addImage(chartImg, 'PNG', 14, currentY, chartWidth, chartHeight);
          currentY += chartHeight + 10;
        };

        // --- Sections ---
        if (this.selectedSection === 'all' || this.selectedSection === 'eventCount') {
          const data = this.eventSummary?.eventCountReports?.map((e: any) => [
            e.eventType, e.eventCount, e.totalCostByEventType
          ]) || [];
          addSection('Event Count Summary', ['Event Type', 'Count', 'Total Cost'], data);
        }

        if (this.selectedSection === 'all' || this.selectedSection === 'gender') {
          const genderReports = this.eventSummary?.userCountByGenderReports || [];
          genderReports.forEach((genderReport: any) => {
            pdf.setFontSize(12);
            pdf.text(`Gender: ${genderReport.gender}`, 14, currentY);
            currentY += 4;
            const details = genderReport.details?.map((d: any) => [
              d.eventType, d.eventCount, d.totalCost
            ]) || [];
            autoTable(pdf, {
              startY: currentY,
              head: [['Event Type', 'Count', 'Total Cost']],
              body: details.length > 0 ? details : [['No records', '', '']],
              theme: 'grid',
              styles: { cellPadding: 3, fontSize: 10, overflow: 'linebreak' },
              headStyles: { fillColor: [41, 128, 185] },
              didDrawPage: (data) => { if (data.cursor?.y != null) currentY = data.cursor.y + 10; }
            });
          });
        }

        if (this.selectedSection === 'all' || this.selectedSection === 'location') {
          const locationReports = this.eventSummary?.eventCountByLocationReports || [];
          locationReports.forEach((locReport: any) => {
            pdf.setFontSize(12);
            pdf.text(`Location: ${locReport.city} ${locReport.state} ${locReport.country}`, 14, currentY);
            currentY += 4;
            const details = locReport.details?.map((d: any) => [
              d.eventType, d.eventCount, d.totalCost
            ]) || [];
            autoTable(pdf, {
              startY: currentY,
              head: [['Event Type', 'Count', 'Total Cost']],
              body: details.length > 0 ? details : [['No records', '', '']],
              theme: 'grid',
              styles: { cellPadding: 3, fontSize: 10, overflow: 'linebreak' },
              headStyles: { fillColor: [41, 128, 185] },
              didDrawPage: (data) => { if (data.cursor?.y != null) currentY = data.cursor.y + 10; }
            });
          });
        }

        if (this.selectedSection === 'all' || this.selectedSection === 'ageRange') {
          const ageReports = this.eventSummary?.eventCountByAgeRangeReports || [];
          ageReports.forEach((ageReport: any) => {
            pdf.setFontSize(12);
            pdf.text(`Age Range: ${this.getAgeRangeLabel(ageReport.ageRange)}`, 14, currentY);
            currentY += 4;
            const details = ageReport.details?.map((d: any) => [
              d.eventType, d.eventCount, d.totalCost
            ]) || [];
            autoTable(pdf, {
              startY: currentY,
              head: [['Event Type', 'Count', 'Total Cost']],
              body: details.length > 0 ? details : [['No records', '', '']],
              theme: 'grid',
              styles: { cellPadding: 3, fontSize: 10, overflow: 'linebreak' },
              headStyles: { fillColor: [41, 128, 185] },
              didDrawPage: (data) => { if (data.cursor?.y != null) currentY = data.cursor.y + 10; }
            });
          });
        }

        const addChartToPDF = (chartId: string, title: string) => {
          const canvas = document.getElementById(chartId) as HTMLCanvasElement;
          if (!canvas) return;

          const chartImg = canvas.toDataURL('image/png', 1.0);
          pdf.addPage();
          pdf.setFontSize(14);
          pdf.text(title, 14, 20);
          pdf.addImage(chartImg, 'PNG', 14, 30, 180, 90);
        };

        addChartToPDF('eventChart', 'Event Count Summary');
        addChartToPDF('genderChart', 'Gender Distribution');
        addChartToPDF('locationChart', 'Location-wise Distribution');

        // ✅ Always save at the end
        pdf.save(`Deal_${deal.uuid}_${this.selectedSection}.pdf`);
      } catch (err) {
        console.error('PDF render error:', err);
        // Save even if partial
        pdf.save(`Deal_${deal.uuid}_${this.selectedSection}_partial.pdf`);
      }
    };

    // Try to load image
    img.onload = () => renderPDF(img);
    img.onerror = () => {
      console.warn('Image load failed, skipping image...');
      renderPDF(); // call without image but still render content
    };
  }

  exportToPDF(dealUUID: string) {
    const deal = this.deal;
    if (!deal) return;

    const pdf = new jsPDF();
    let currentY = 20;

    const productImg = environment.assetsUrl + `/assets/${deal.product_image}`;
    const img = new Image();
    img.crossOrigin = 'Anonymous';
    img.src = productImg;

    const renderPDF = (imgRef?: HTMLImageElement) => {
      try {
        let imgWidth = 40;
        let imgHeight = 0;
        if (imgRef) {
          imgHeight = (imgRef.height / imgRef.width) * imgWidth;
          pdf.addImage(imgRef, 'PNG', 14, currentY, imgWidth, imgHeight);
        }

        let textX = imgRef ? 14 + imgWidth + 10 : 14;
        pdf.setFontSize(14);
        pdf.setFont('helvetica', 'bold');
        pdf.text(`${deal.product_name}`, textX, currentY + 8);

        pdf.setFontSize(11);
        pdf.text(`${deal.product_name} - created_by_entity`, textX, currentY + 15);

        // Discount or Coupon
        if (deal.dealType === 'promotions') {
          pdf.text(`Discounted Price:`, textX, currentY + 25);
          pdf.text(`${deal.discountedPrice}`, textX + 40, currentY + 25);
        } else {
          pdf.text(`Coupon Code:`, textX, currentY + 25);
          pdf.text(`${deal.coupon_code}`, textX + 40, currentY + 25);
        }

        const descriptionText = `Description: ${this.deal.product_description}`;
        const wrappedDescription = pdf.splitTextToSize(descriptionText, 100);
        pdf.text(wrappedDescription, textX, currentY + 35);
        currentY = currentY + 35 + (wrappedDescription.length * 5);

        // ✅ Add current date just below description
        const currentDate = new Date();
        const formattedDate = currentDate.toLocaleDateString('en-GB', {
          day: '2-digit', month: 'short', year: 'numeric',
          hour: '2-digit', minute: '2-digit'
        });

        pdf.setFontSize(10);
        pdf.setTextColor(100);
        pdf.text(`Report Generated On: ${formattedDate}`, textX, currentY + 6);
        currentY += 13; // space before next section



        // --- Horizontal Line ---
        currentY += 5;
        pdf.setDrawColor(0);
        pdf.setLineWidth(0.5);
        pdf.line(14, currentY, 200, currentY);

        currentY += 5;
        pdf.setFontSize(11);
        pdf.setFont('helvetica', 'bold');

        // Budget/Spend info
        pdf.text(`Budget:`, 20, currentY);
        pdf.text(`$${this.reportTotalBudget}`, 45, currentY);

        pdf.text(`Total Spent:`, 65, currentY);
        pdf.text(`$${this.reportTotalSpent}`, 100, currentY);

        pdf.text(`Charged Till Now:`, 130, currentY);
        pdf.text(`$${this.reportSpendCharged}`, 170, currentY);

        currentY += 6;
        pdf.setLineWidth(0.5);
        pdf.line(14, currentY, 200, currentY);

        currentY += 10;

        // // ✅ Helper: render chart below the table (not full page)
        // const addChartInline = (chartId: string, title: string) => {
        //   const canvas = document.getElementById(chartId) as HTMLCanvasElement;
        //   if (!canvas) return;

        //   const chartImg = canvas.toDataURL('image/png', 1.0);
        //   const chartWidth = 90; // half page width
        //   const chartHeight = 60; // smaller height

        //   // Check for page overflow
        //   if (currentY + chartHeight + 10 > 280) {
        //     pdf.addPage();
        //     currentY = 20;
        //   }

        //   pdf.setFontSize(11);
        //   pdf.text(title, 14, currentY);
        //   currentY += 5;

        //   pdf.addImage(chartImg, 'PNG', 14, currentY, chartWidth, chartHeight);
        //   currentY += chartHeight + 10;
        // };

        // ────────────────────────────────────────────────
        // ✅ Helper: Beautified inline chart renderer
        // ────────────────────────────────────────────────
        const addChartInline = (chartId: string, title: string) => {
          const canvas = document.getElementById(chartId) as HTMLCanvasElement;
          if (!canvas) return;

          const chartImg = canvas.toDataURL('image/png', 1.0);
          const chartWidth = 100; // slightly more than half width
          const chartHeight = 65;

          // Page overflow check
          if (currentY + chartHeight + 25 > 280) {
            pdf.addPage();
            currentY = 20;
          }

          // Chart title
          pdf.setFontSize(12);
          pdf.setFont('helvetica', 'bold');
          pdf.text(title, 14, currentY);

          // Chart image
          pdf.setDrawColor(180);
          pdf.setLineWidth(0.2);
          pdf.roundedRect(14, currentY + 4, chartWidth + 2, chartHeight + 4, 3, 3);
          pdf.addImage(chartImg, 'PNG', 16, currentY + 6, chartWidth - 2, chartHeight - 2);

          currentY += chartHeight + 20;

          // Decorative section end line
          pdf.setDrawColor(100);
          pdf.setLineWidth(0.3);
          pdf.line(14, currentY, 200, currentY);
          currentY += 8;
        };

        // ✅ Table helper
        const addSection = (sectionTitle: string, headers: string[], data: any[][], chartId?: string) => {
          pdf.setFontSize(12);
          pdf.text(sectionTitle, 14, currentY);
          currentY += 5;

          autoTable(pdf, {
            startY: currentY,
            head: [headers],
            body: data.length > 0 ? data : [['No records', '', '']],
            theme: 'grid',
            styles: { cellPadding: 3, fontSize: 10, overflow: 'linebreak' },
            headStyles: { fillColor: [41, 128, 185] },
            didDrawPage: (data) => {
              if (data.cursor?.y != null) {
                currentY = data.cursor.y + 10;
              }
            }
          });

          // Add chart just below the table (if present)
          if (chartId) {
            addChartInline(chartId, `${sectionTitle} (Chart)`);
          }
          else {
            // Only draw horizontal line if no chart
            pdf.setDrawColor(100);
            pdf.setLineWidth(0.3);
            pdf.line(14, currentY, 200, currentY);
            currentY += 8;
          }
        };

        // --- Sections ---
        if (this.selectedSection === 'all' || this.selectedSection === 'eventCount') {
          const data = this.eventSummary?.eventCountReports?.map((e: any) => [
            e.eventType, e.eventCount, e.totalCostByEventType
          ]) || [];
          addSection('Event Count Summary', ['Event Type', 'Count', 'Total Cost'], data, 'eventChart');
        }

        if (this.selectedSection === 'all' || this.selectedSection === 'gender') {
          const genderReports = this.eventSummary?.userCountByGenderReports || [];
          genderReports.forEach((genderReport: any, i: number) => {
            pdf.setFontSize(12);
            pdf.text(`Gender: ${genderReport.gender}`, 14, currentY);
            currentY += 4;
            const details = genderReport.details?.map((d: any) => [
              d.eventType, d.eventCount, d.totalCost
            ]) || [];
            autoTable(pdf, {
              startY: currentY,
              head: [['Event Type', 'Count', 'Total Cost']],
              body: details.length > 0 ? details : [['No records', '', '']],
              theme: 'grid',
              styles: { cellPadding: 3, fontSize: 10, overflow: 'linebreak' },
              headStyles: { fillColor: [41, 128, 185] },
              didDrawPage: (data) => { if (data.cursor?.y != null) currentY = data.cursor.y + 10; }
            });
          });

          // Add gender chart inline
          addChartInline('genderChart', 'Gender Distribution');
        }

        if (this.selectedSection === 'all' || this.selectedSection === 'location') {
          const locationReports = this.eventSummary?.eventCountByLocationReports || [];
          locationReports.forEach((locReport: any) => {
            pdf.setFontSize(12);
            pdf.text(`Location: ${locReport.city} ${locReport.state} ${locReport.country}`, 14, currentY);
            currentY += 4;
            const details = locReport.details?.map((d: any) => [
              d.eventType, d.eventCount, d.totalCost
            ]) || [];
            autoTable(pdf, {
              startY: currentY,
              head: [['Event Type', 'Count', 'Total Cost']],
              body: details.length > 0 ? details : [['No records', '', '']],
              theme: 'grid',
              styles: { cellPadding: 3, fontSize: 10, overflow: 'linebreak' },
              headStyles: { fillColor: [41, 128, 185] },
              didDrawPage: (data) => { if (data.cursor?.y != null) currentY = data.cursor.y + 10; }
            });
          });

          // Add chart below
          addChartInline('locationChart', 'Location-wise Distribution');
        }

        if (this.selectedSection === 'all' || this.selectedSection === 'ageRange') {
          const ageReports = this.eventSummary?.eventCountByAgeRangeReports || [];
          ageReports.forEach((ageReport: any) => {
            pdf.setFontSize(12);
            pdf.text(`Age Range: ${this.getAgeRangeLabel(ageReport.ageRange)}`, 14, currentY);
            currentY += 4;
            const details = ageReport.details?.map((d: any) => [
              d.eventType, d.eventCount, d.totalCost
            ]) || [];
            autoTable(pdf, {
              startY: currentY,
              head: [['Event Type', 'Count', 'Total Cost']],
              body: details.length > 0 ? details : [['No records', '', '']],
              theme: 'grid',
              styles: { cellPadding: 3, fontSize: 10, overflow: 'linebreak' },
              headStyles: { fillColor: [41, 128, 185] },
              didDrawPage: (data) => { if (data.cursor?.y != null) currentY = data.cursor.y + 10; }
            });
          });
        }

        // ✅ Save PDF
        pdf.save(`Deal_${deal.uuid}_${this.selectedSection}.pdf`);
      } catch (err) {
        console.error('PDF render error:', err);
        pdf.save(`Deal_${deal.uuid}_${this.selectedSection}_partial.pdf`);
      }
    };

    img.onload = () => renderPDF(img);
    img.onerror = () => renderPDF();
  }




  viewDetails(events: any) {
    debugger
    this.router.navigate(['/eventreport/deal-events/events-logs'], {
      state: {
        deal: this.deal,  // 🔁 reusing the deal you received earlier
        events: events    // 🔁 passing the new events object
      }
    });

  }
  getStatusLabel(status: string): string {
    switch (status) {
      case 'P': return this.reportPlaceHolders['LBL_PENDING'];
      case 'A': return this.reportPlaceHolders['LBL_ACTIVE'];
      case 'I': return this.reportPlaceHolders['LBL_INACTIVE'];
      case 'D': return this.reportPlaceHolders['LBL_DRAFT'];
      case 'C': return this.reportPlaceHolders['LBL_COMPLETED'];
      case 'E': return this.reportPlaceHolders['LBL_EXPIRED'];
      default: return status;
    }
  }

  getStatusClass(status: string): any {
    switch (status) {
      case 'A': return 'active-chip';
      case 'P': return 'pending-chip';
      case 'S': return 'paused-chip'
      case 'E': return 'expired-chip';
      case 'IA': return 'inactive-chip';
      case 'D': return 'draft-chip';
      case 'U': return 'upcoming-chip';
      case 'R': return 'rejected-chip';
      case 'N': return 'new-chip';
      case 'C': return 'completed-chip';
      default: return '';
    }
  }

  goBack() {
    this.router.navigate(['/eventreport']);
  }




}
